import { request } from '@/api/index';
export function getList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    params: {},
    data: {}
  };
  return request({
    url: '/api/ConfirmExtension/CallPageDatas',
    method: 'post',
    data: data.data,
    params: data.params
  });
}
export function getDetail(params) {
  return request({
    url: '/api/ConfirmExtension/CallDetails',
    method: 'get',
    params: params
  });
}